import gql from "graphql-tag";

export const markGameAsPlayedGQL = gql`
  mutation MarkGameAsPlayed($gameId: String!) {
    markGameAsPlayed(gameId: $gameId) {
      message
    }
  }
`;
